module.exports = __webpack_public_path__ + "img/bj.2c822cc1.png";